import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core'
import { List, ListItem, ListItemIcon, ListItemText, Checkbox, Divider } from '@material-ui/core'
import IconBilingual from '@material-ui/icons/Translate'
import IconMonolingual from '@material-ui/icons/Title'
import lodash from 'lodash'

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    margin: theme.spacing.unit * 2,
    padding: theme.spacing.unit * 2,
    height: '60vh',
    overflowY: 'scroll'
  },
  list: {
    width: '40vw',
    maxWidth: 640
  },
  divider: {
    margin: theme.spacing.unit * 2
  },
  selectedNote: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
})

class SearchScopeSelectionBox extends React.Component {
  handleToggle = (value) => () => {
    const { classes, bookList, checkedList, onChange } = this.props
    const bilingualIdList = Object.keys(bookList.bilingual).map(bookCode => bookList.bilingual[bookCode].en.id)
    const monolingualIdList = bookList.monolingual.map(monoBook => monoBook.id)
    let resultList = []

    if (!checkedList) {
      // checkedList is null, ==> no current selection ==> select all except current value
      console.debug(`checkedList is null, select all except ${value}`)
      resultList = lodash.without(lodash.union(bilingualIdList, monolingualIdList), value)
    } else if (checkedList && checkedList.indexOf(value) > -1) {
      console.debug(`currently selected. remove ${value}`)
      resultList = lodash.without(checkedList, value)
    } else {
      console.debug(`currently not selected. add ${value}`)
      resultList = lodash.union(checkedList, [value])
    }
    console.debug(`toggle for ${value}`)
    console.debug(`resultList = ${resultList}`)
    this.props.onChange(resultList)
  }

  render () {
    const { classes, bookList, checkedList, onChange } = this.props
    const bilingualIdList = Object.keys(bookList.bilingual).map(bookCode => bookList.bilingual[bookCode].en.id)
    const monolingualIdList = bookList.monolingual.map(monoBook => monoBook.id)
    const bilingualSelectedAll = !checkedList || lodash.intersection(bilingualIdList, checkedList).length === bilingualIdList.length
    const bilingualSelectedNone = checkedList && lodash.intersection(bilingualIdList, checkedList).length === 0
    const bilingualSelectedSome = checkedList && lodash.intersection(bilingualIdList, checkedList).length > 0 && lodash.intersection(bilingualIdList, checkedList).length < bilingualIdList.length

    const monolingualSelectedAll = !checkedList || lodash.intersection(monolingualIdList, checkedList).length === monolingualIdList.length
    const monolingualSelectedNone = checkedList && lodash.intersection(monolingualIdList, checkedList).length === 0
    const monolingualSelectedSome = checkedList && lodash.intersection(monolingualIdList, checkedList).length > 0 && lodash.intersection(monolingualIdList, checkedList).length < monolingualIdList.length

    return (
      <Paper className={classes.root} elevation={4}>
        <Typography variant="h4" gutterBottom>Parallel Corpus</Typography>
        <div className={classes.selectedNote}>
          <Checkbox
            checked={bilingualSelectedAll}
            indeterminate={bilingualSelectedSome}
            onChange={(evt, checked) => {
              if (bilingualSelectedNone) {
                this.props.onChange(lodash.union(checkedList, bilingualIdList))
              } else if (bilingualSelectedAll) {
                this.props.onChange(lodash.difference(checkedList, bilingualIdList))
              } else {
                // select all if some selected
                this.props.onChange(lodash.union(checkedList, bilingualIdList))
              }
            }}
          />
          <Typography variant="body1" gutterBottom>{`${checkedList ? lodash.intersection(checkedList, bilingualIdList).length : bilingualIdList.length} selected`}</Typography>
        </div>
        <List className={classes.list}>
          {Object.keys(bookList.bilingual).map(bookCode => {
            const thisId = bookList.bilingual[bookCode].en.id
            const bookTitle = `${bookList.bilingual[bookCode].en.name} / ${bookList.bilingual[bookCode].cn.name}`
            return (
              <ListItem key={bookCode} dense button onClick={this.handleToggle(thisId)}>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    disableRipple
                    checked={!checkedList || checkedList.indexOf(thisId) !== -1}
                  />
                </ListItemIcon>
                <ListItemText primary={bookTitle} />
                <IconBilingual/>
              </ListItem>
            )
          })}
        </List>
        <Divider className={classes.divider}/>
        <Typography variant="h4" gutterBottom>Monolingual Corpus</Typography>
        <div className={classes.selectedNote}>
          <Checkbox
            checked={monolingualSelectedAll}
            indeterminate={monolingualSelectedSome}
            onChange={(evt, checked) => {
              if (monolingualSelectedNone) {
                this.props.onChange(lodash.union(checkedList, monolingualIdList))
              } else if (monolingualSelectedAll) {
                this.props.onChange(lodash.difference(checkedList, monolingualIdList))
              } else {
                // select all if some selected
                this.props.onChange(lodash.union(checkedList, monolingualIdList))
              }
            }}
          />
          <Typography variant="body1" gutterBottom>{`${checkedList ? lodash.intersection(checkedList, monolingualIdList).length : monolingualIdList.length} selected`}</Typography>
        </div>
        <List className={classes.list}>
          {bookList.monolingual.map(monoBook => {
            const thisId = monoBook.id
            const bookTitle = monoBook.name
            return (
              <ListItem key={thisId} dense button onClick={this.handleToggle(thisId)}>
                <ListItemIcon>
                  <Checkbox
                    edge="start"
                    checked={!checkedList || checkedList.indexOf(thisId) !== -1}
                  />
                </ListItemIcon>
                <ListItemText primary={bookTitle} />
                <IconMonolingual/>
              </ListItem>
            )
          })}
        </List>
      </Paper>
    )
  }
}

export default withStyles(styles)(SearchScopeSelectionBox)